"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.applyMax = void 0;
const utilityFunctions_1 = require("../../utilities/utilityFunctions");
function applyMax(factory, src, keySelector, selector) {
    if (!selector) {
        return factory
            .createBasicEnumerable((0, utilityFunctions_1.getIterableGenerator)(src))
            .aggregate((prev, curr) => (keySelector(prev) >= keySelector(curr) ? prev : curr));
    }
    return factory
        .createBasicEnumerable((0, utilityFunctions_1.getIterableGenerator)(src))
        .select(selector)
        .aggregate((prev, curr) => (prev >= curr ? prev : curr));
}
exports.applyMax = applyMax;
//# sourceMappingURL=applyMax.js.map